import { Component, Input } from '@angular/core';
import { DsChipColorVariant } from '@levelaccess/design-system';
import { flawStatus } from '../../../../../../../shared/constants/flaw';
import { RuleAuditHistoryType } from '../../../../../../../shared/constants/rule-audit-history';
import { IFlaw } from '../../../../../../../shared/interfaces/flaw.interface';
import { BaseCellComponent, ICellConfig } from '../base-cell/base-cell.component';

export interface IIssueStateLabelCellConfig extends ICellConfig {
  status: flawStatus;
  hasHistory: boolean;
  flaw?: IFlaw;
  tabIndex?: number;
}

@Component({
  selector: 'table-cell-issue-state',
  styleUrls: ['../base-cell/base-cell.component.scss'],
  standalone: false,
  styles: [
    `
      div {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
      }

      button {
        padding: 3px 4px;
        border: 1px solid #757575;
        border-radius: 4px;
      }
    `,
  ],
  template: `
    <div>
      <span tabindex="{{ config.tabIndex || 0 }}" #ref>
        <ds-chip
          [text]="
            config.status === flawStatus.dismissed ? ('label_dismissed' | translate) : ('label_' + config.status | translate)
          "
          [colorVariant]="getStatusChipVariant(config.status)"
        ></ds-chip>
      </span>
      @if (config.hasHistory) {
        <app-view-flaw-status-history [issueSource]="config.flaw._id"></app-view-flaw-status-history>
      }
    </div>
  `,
})
export class IssueStateLabelCellComponent extends BaseCellComponent {
  @Input() public config: IIssueStateLabelCellConfig;
  public type: RuleAuditHistoryType = RuleAuditHistoryType.issue;
  public flawStatus: typeof flawStatus = flawStatus;
  public readonly DsChipColorVariant: typeof DsChipColorVariant = DsChipColorVariant;

  public getStatusChipVariant(status: flawStatus): DsChipColorVariant {
    switch (status) {
      case flawStatus.closed:
        return DsChipColorVariant.LightGray;
      case flawStatus.dismissed:
        return DsChipColorVariant.Red;
      case flawStatus.open:
      case flawStatus.reOpen:
      default:
        return DsChipColorVariant.Success;
    }
  }
}
